import React from "react";
import "./Navigation.css";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import {SettingsDoc, User} from "../types/Types";
import {getAuth, onAuthStateChanged} from "@firebase/auth";
import {collection, getDocs, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import {isChatEnabled} from "../util/Util";

interface Props {
  currentUser: User | undefined;
  settings: SettingsDoc | undefined;
}

class Navigation extends React.PureComponent<Props, {}> {
  public componentDidMount() {
    const auth = getAuth();
    onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        this.setState({ currentUser: null });
        return;
      }
      const userCollection = query(collection(db, 'users'), where('authId', '==', currentUser.uid));
      const userCollectionSnap = await getDocs(userCollection);
      userCollectionSnap.forEach((userDoc) => {
        this.setState({ currentUser: userDoc.data() as User });
        return;
      });
    });
  }

  public render() {
    return (
      <Container>
        <Nav variant="pills" className="my-3 mr-auto">
          {this.props.currentUser &&
          <>
            <NavLink className="nav-link" to="/pubs">
              Pubs
            </NavLink>
            <NavLink className="nav-link" to="/leaderboard/visits">
              Users
            </NavLink>
            <NavLink className="nav-link" to="/map">
              Map
            </NavLink>
            {!this.props.currentUser.socialDisabled && <NavLink className="nav-link" to="/hub/visits">
              Hub
            </NavLink>}
            {this.props.currentUser
              && !this.props.currentUser.socialDisabled
              && isChatEnabled(this.props.currentUser, this.props.settings)
              && <NavLink className="nav-link" to="/chat/general" onClick={(e) => this.navigateToChat("general")}>
              Chat
            </NavLink>}
          </>}
          <div className="ml-auto">
            <NavDropdown title="More" id="basic-nav-dropdown">
              {this.props.currentUser && this.props.currentUser.admin && (
                <NavDropdown.Item as={NavLink} to="/admin-page">
                  Admin
                </NavDropdown.Item>
              )}
              {this.props.currentUser && this.props.currentUser.id === "XF6i86GWnUh6pFR8GvKr93bFsOu2" && (
                <NavDropdown.Item as={NavLink} to="/admin-home">
                  Super Admin
                </NavDropdown.Item>
              )}
              {(
                <NavDropdown.Item as={NavLink} to="/events">
                  Calendar
                </NavDropdown.Item>
              )}
              {this.props.currentUser && (
                <NavDropdown.Item as={NavLink} to={`/journey/${this.props.currentUser.id}`}>
                  Journey
                </NavDropdown.Item>
              )}
              <NavDropdown.Item as={NavLink} to="/updates">
                What's New
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/support">
                Support
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Nav>
      </Container>
    );
  }

  private navigateToChat = (channel: string) => {
    //history.push("/chat/" + channel);
    //window.location.reload();
  }
}

export default Navigation;
